export const DEFAULT_DISTRICT_CONTACTS_TITLE = 'Contacts';

export const getDistrictContactsTitle = records => {
  const recordList = Array.isArray(records) ? records : [];
  const customTitle = recordList
    .map(record => String(record?.[59]?.value || '').trim())
    .find(Boolean);
  return customTitle || DEFAULT_DISTRICT_CONTACTS_TITLE;
};
